import Vue from 'vue'
import axios from 'axios'
import dayjs from 'dayjs'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import myMixin from '@/mixin.js'

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 初始化css
import '@/style/lib.css'
import '@/style/hsy.scss'
import '@/style/rel.scss'

//wow
import 'animate.css/animate.min.css'

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
import zh from '@/common/lang/zh'
import en from '@/common/lang/en'
const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'zh',
  messages: {
    zh: zh,
    en: en
  }
})

// Vue.prototype.$baseUrl = 'http://127.0.0.1:2333/api'
Vue.prototype.$baseUrl = 'https://ocmserver.ocmfoods.com/api'
Vue.prototype.$strapiUrl = 'https://admin.ocmfoods.com/api'

Vue.prototype.$http = axios
Vue.prototype.$dayjs = dayjs

Vue.mixin(myMixin)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
